/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional attributes shown in the aisWeb display. The fields are purely informational and the contents is not used by aisWeb.
 * @export
 * @interface ErpAttributes
 */
export interface ErpAttributes {
    /**
     * 
     * @type {string}
     * @memberof ErpAttributes
     */
    key?: string;
    /**
     * Type is string by default, but can also be a boolean or a number
     * @type {string}
     * @memberof ErpAttributes
     */
    value?: string;
    /**
     * string, boolean, number, datetime and enum. Default is string
     * @type {string}
     * @memberof ErpAttributes
     */
    datatype?: string;
    /**
     * Indicates whether the ERP system can accept external changes. I.e. field should be editable in aisWeb
     * @type {boolean}
     * @memberof ErpAttributes
     */
    edit?: boolean;
    /**
     * Indicates whether the key field should be editable in aisWeb
     * @type {boolean}
     * @memberof ErpAttributes
     */
    editKey?: boolean;
}

/**
 * Check if a given object implements the ErpAttributes interface.
 */
export function instanceOfErpAttributes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ErpAttributesFromJSON(json: any): ErpAttributes {
    return ErpAttributesFromJSONTyped(json, false);
}

export function ErpAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErpAttributes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'datatype': !exists(json, 'datatype') ? undefined : json['datatype'],
        'edit': !exists(json, 'edit') ? undefined : json['edit'],
        'editKey': !exists(json, 'editKey') ? undefined : json['editKey'],
    };
}

export function ErpAttributesToJSON(value?: ErpAttributes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
        'datatype': value.datatype,
        'edit': value.edit,
        'editKey': value.editKey,
    };
}

